import { render, staticRenderFns } from "./VariantForm.vue?vue&type=template&id=e19bf5ba&lang=pug"
import script from "./VariantForm.vue?vue&type=script&lang=js"
export * from "./VariantForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports